import React, { Component } from 'react'
import { StyleRoot } from 'radium'
import RegistrationContainer from '../Login/registrationContainer'
import { connect } from 'cerebral-view-react'
import FormsWrapper from '../User/FormsWrapper'
import DotSpinner from './dotSpinner'
import SignedInContainer from '../User/SignedInContainer'
import AdminWrapper from '../User/AdminWrapper'
import UserList from '../User/UserList'
import { t } from '@billes/translator-client'
import Dialog from '../common/dialog/GDPR'
import LoginMethodSelector from './LoginMethodSelector'
import NewPasswordDialog from '../common/dialog/newPassword'

class MissingPage extends Component {
  render(){
    const homepage = `${window.location.protocol}//${window.location.hostname}`

    return <p style={{ fontSize: 14 }}>You have reached a page that doesn't exist. You can return to the homepage by going to <a href={homepage}>{homepage}</a>.</p>
  }
}

class App extends Component {

  constructor(props){
    super(props)
    this.state = {
      retryCountdown: props.retryTime
    }
  }

  componentDidMount(){
    if(this.props.hasSSOError) {
      this.retryId = setInterval(() => {
        const retryCountdown = this.state.retryCountdown - 1
        this.setState((prev) => ({...prev, retryCountdown}))
        if(retryCountdown < 1) clearInterval(this.retryId)
      }, 1000)
    }
  }

  componentWillUnmount() {
    clearInterval(this.retryId)
  }

  onAppClick() {
    const { signals } = this.props
    signals.client.focusField({ focus: false })
  }

  getBackgroundStyle() {
    const { registrationBackgroundImage, windowWidth } = this.props
    if (!registrationBackgroundImage || windowWidth < 600) {
      return null
    }

    return ` no-repeat top left fixed url(${registrationBackgroundImage})`
  }

  getLoggedInPageView() {
    const { currentPage } = this.props
    let part = ''
    let uriSplit = currentPage.split('/')
    if (uriSplit.length === 3) {
      part = uriSplit[2]
    }
    switch (currentPage) {
      case 'welcome':
        return {
          component: <FormsWrapper />,
          heading: t('bus-client.myAccount')
        }
      case 'users/add':
        return {
          component: <FormsWrapper />,
          heading: t('bus-client.createAccount')
        }
      case `user/edit/${part}`:
        return {
          component: <FormsWrapper />,
          heading: t('bus-client.editAccount')
        }
      case 'users':
        return {
          component: (
            <AdminWrapper>
              <UserList />
            </AdminWrapper>
          ),
          heading: t('bus-client.listUsers')
        }
      case 'users/unapproved':
        return {
          component: (
            <AdminWrapper>
              <UserList />
            </AdminWrapper>
          ),
          heading: t('bus-client.unapprovedUsers')
        }
      default: {
        return {
          component: <MissingPage />,
          heading: 'Oops! This page seems to be missing!'
        }
      }
    }
  }

  getBackgroundDiv() {
    const { windowWidth } = this.props
    if (windowWidth < 600) {
      return null
    }

    return (
      <div
        style={{
          float: 'left',
          height: '100%',
          width: 'calc(100% - 450px)',
          backgroundColor: '#efefef',
          background: this.getBackgroundStyle(),
          backgroundSize: 'cover'
        }}
      />
    )
  }

  getPageView() {
    const { user, currentPage } = this.props
    if (user && currentPage !== 'login') {
      const { component, heading } = this.getLoggedInPageView()
      return (
        <SignedInContainer heading={heading}>
          <Dialog />
          <NewPasswordDialog />
          {component}
        </SignedInContainer>
      )
    }

    switch (currentPage) {
      case 'selectLoginMethod':
        return <LoginMethodSelector />
      case 'login':
      default:
        return (
          <div
            style={{ height: '100%', width: '100%', outline: 'none' }}
            onTouchEnd={() => this.onAppClick()}
            onMouseUp={() => this.onAppClick()}
          >
            <div
              style={{
                position: 'absolute',
                left: 0,
                height: '100%',
                width: '100%'
              }}
            >
              <div
                style={{
                  position: 'relative',
                  height: '100%',
                  width: '100%'
                }}
              >
                {this.getBackgroundDiv()}
                <div style={{ float: 'left', height: '100%' }}>
                  <RegistrationContainer />
                </div>
              </div>
            </div>
          </div>
        )
    }
  }

  render() {
    const { loaded, currentPage, device, hasSSOError } = this.props
    if (!loaded || !currentPage) {
      return (
        <StyleRoot>
          <div
            style={{
              left: '50%',
              top: '45%',
              transform: 'translate(-50%, -50%)',
              position: 'fixed',
              zIndex: 3000,
              textAlign: 'center'
            }}
          >
            { hasSSOError && <h3>Could not authenticate, retrying in {this.state.retryCountdown} </h3> }
            <DotSpinner
              kind={
                device === 'mobile' || device === 'tablet' ? 'Small' : 'Large'
              }
            />
          </div>
        </StyleRoot>
      )
    }
    return this.getPageView()
  }
}

export default connect({
  loaded: 'app.loaded',
  currentPage: 'client.currentPage',
  user: 'client.user',
  registrationBackgroundImage: 'client.registrationBackgroundImage',
  windowWidth: 'useragent.window.width',
  portrait: 'useragent.media.portrait',
  device: 'useragent.device.type',
  locale: 'client.selectedLocale',
  hasSSOError: 'app.sso.hasError',
  retryTime: 'app.sso.retryAfterSeconds'
})(App)



// WEBPACK FOOTER //
// ./src/components/App/index.js